"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
require("./Dattable/pcoded.js");
require("./Components/ExpandViewComponent.ts");
require("./App.jquery.ts");
require("./App.knockout.ts");
$(function () {
    var activeSidebarUserMenu = null;
    function closeSidebarUserMenu() {
        if (!activeSidebarUserMenu) {
            return;
        }
        activeSidebarUserMenu.removeClass("show");
        activeSidebarUserMenu.find(".dropdown-toggle").attr("aria-expanded", "false");
        activeSidebarUserMenu.find(".dropdown-menu").removeClass("show").removeAttr("style");
        activeSidebarUserMenu = null;
    }
    function positionSidebarUserMenu(menu) {
        var anchor = menu.closest(".sidebar-user-menu-anchor")[0];
        var dropdownMenu = menu.find(".dropdown-menu")[0];
        if (!anchor || !dropdownMenu) {
            return;
        }
        var anchorRect = anchor.getBoundingClientRect();
        var width = Math.max(dropdownMenu.offsetWidth, 290);
        var left = Math.max(8, Math.min(anchorRect.right - width, window.innerWidth - width - 8));
        var top = Math.max(8, anchorRect.top - dropdownMenu.offsetHeight);
        $(dropdownMenu).css({
            position: "fixed",
            top: "".concat(top, "px"),
            left: "".concat(left, "px"),
            right: "auto",
            bottom: "auto",
            transform: "none",
            width: "".concat(width, "px")
        });
    }
    $(".sidebar-user-footer .drp-user").addClass("dropup");
    $(".sidebar-user-footer .dropdown-toggle").on("click", function (event) {
        event.preventDefault();
        event.stopPropagation();
        var menu = $(this).closest(".drp-user");
        if (activeSidebarUserMenu && activeSidebarUserMenu[0] === menu[0]) {
            closeSidebarUserMenu();
            return;
        }
        closeSidebarUserMenu();
        activeSidebarUserMenu = menu;
        menu.addClass("show");
        $(this).attr("aria-expanded", "true");
        menu.find(".dropdown-menu").addClass("show");
        positionSidebarUserMenu(menu);
    });
    $(".pcoded-navbar .navbar-content").on("scroll", function () {
        if (activeSidebarUserMenu) {
            positionSidebarUserMenu(activeSidebarUserMenu);
        }
    });
    $(window).on("resize", function () {
        if (activeSidebarUserMenu) {
            positionSidebarUserMenu(activeSidebarUserMenu);
        }
    });
    $(document).on("click", function (event) {
        if (activeSidebarUserMenu && !$(event.target).closest(".sidebar-user-footer .drp-user").length) {
            closeSidebarUserMenu();
        }
    });
});
